// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3fn4i","brand":"header_brand__dcoOg"};